import { MembershipType, User } from '../types';

export const determineIsStudent = (user: User | null) =>
    user &&
    user.memberships[0] &&
    user.memberships[0].m_type === MembershipType.STUDENT;

export const determineIsTutor = (user: User | null) =>
    user &&
    user.memberships[0] &&
    user.memberships[0].m_type === MembershipType.TUTOR;

export const hasMembershipRole = (
    user: User | null,
    membershipRole: MembershipType,
) =>
    user &&
    user.memberships[0] &&
    user.memberships[0].m_type === membershipRole;

export const getUserRole = (user: User) =>
    user && user.memberships[0] && user.memberships[0].m_type;
